// extracted by mini-css-extract-plugin
export default {"locationContainer":"hotel_location_locationContainer__nsL7C","icon":"hotel_location_icon__1V3Lm"};